import React, { Component } from "react";
import Filter from "./Report.EquipmentFilter";
import Report from "./Report.DetailsReport";
import Dispose from "./Report.DisposeMultiple";

export default class Eqipment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "Filter",
      data: null
    };
    this.handleClick = this.handleClick.bind(this);
  }
  render() {
    if (this.state.mode === "Filter") {
      return (
        <Filter
          onClick={this.handleClick}
          reportType={this.props.reportSubType}
        />
      );
    } else if (this.state.mode === "Tracker") {
      return <Report data={this.state.data} onCloseClick={this.handleClick} />;
    } else if (this.state.mode === "Dispose") {
      return <Dispose data={this.state.data} onCloseClick={this.handleClick} />;
    }
  }

  handleClick(mode, data) {
    this.setState({ mode, data });
  }
}
